import { render, staticRenderFns } from "./ReceiptInfoTable.vue?vue&type=template&id=01d8d855&scoped=true"
import script from "./ReceiptInfoTable.vue?vue&type=script&lang=js"
export * from "./ReceiptInfoTable.vue?vue&type=script&lang=js"
import style0 from "./ReceiptInfoTable.vue?vue&type=style&index=0&id=01d8d855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8d855",
  null
  
)

export default component.exports